const bcDatasetInitState = {
  loading: false,
  error: {},
  datasets: [],
  message: null,
  isError: false,
  resetForm: true
};

export default function bcDatasetReducer(state = bcDatasetInitState, action) {
  switch (action.type) {
    case 'FETCH_BC_DATASETS_START':
      return { ...state, loading: true };

    case 'FETCH_BC_DATASETS_SUCCESS':
      return { ...state, loading: false, error: {}, datasets: action.payload.datasets };

    case 'FETCH_BC_DATASETS_FAILED':
      return { ...state, loading: false, error: action.payload.error };

    case 'CREATE_BC_DATASET_SUCCESS':
      return { ...state, message: 'Successfully saved BC dataset override', isError: false, resetForm: true };

    case 'CREATE_BC_DATASET_FAILED': {
      const message = (action.payload.error && action.payload.error.data && action.payload.error.data.message)
        || 'Failed to save BC dataset override';
      return { ...state, message, isError: true, resetForm: false };
    }

    case 'DELETE_BC_DATASET_SUCCESS':
      return { ...state, message: 'Successfully deleted BC dataset override', isError: false };

    case 'DELETE_BC_DATASET_FAILED': {
      const message = (action.payload.error && action.payload.error.data && action.payload.error.data.message)
        || 'Failed to delete BC dataset override';
      return { ...state, message, isError: true };
    }

    case 'SYNC_CLEAR_SOURCE_MESSAGE':
      return { ...state, message: null, isError: false };

    default:
      return state;
  }
}
